import React from 'react'
import RoofModel from './RoofModel'
import TrimModel from './TrimModel'

const Roof = () => {
    return (
        <>
            <RoofModel/>
            <TrimModel/>
        </>
    )
}

export default Roof